import { CultureInfo } from '../culture-info.model';
import { CultureInfoMs } from './ms';

/**
 * @ignore
 */
export const CultureInfoMsSG: CultureInfo = {
  name: 'ms-SG',
  displayName: 'Bahasa Melayu (Singapura)',
  iso3LanguageCode: 'msa',
  iso2LanguageCode: 'ms',
  ietfLanguageTag: 'ms-SG',
  parent: CultureInfoMs
};
